import * as React from "react";
function assign(ref, value) {
  if (typeof ref === "function") {
    const result = ref(value);
    return typeof result === "function" ? result : void 0;
  }
  if (ref != null) ref.current = value;
  return void 0;
}
function mergeRefs(...refs) {
  let cleanups = null;
  const detach = () => {
    const pending = cleanups;
    cleanups = null;
    if (!pending) return;
    refs.forEach((ref, index) => {
      const cleanup = pending[index];
      if (cleanup) cleanup();
      else assign(ref, null);
    });
  };
  return (node) => {
    if (node === null) {
      detach();
      return void 0;
    }
    detach();
    cleanups = refs.map((ref) => assign(ref, node));
    return detach;
  };
}
function useMergedRefs(...refs) {
  return React.useMemo(() => mergeRefs(...refs), refs);
}
export {
  mergeRefs,
  useMergedRefs
};
//# sourceMappingURL=refs.js.map
